<template>
    <div class="post" :class="{ 'metas': metas }">
        <a :href="`/Post/${entity?.id}`" target="_blank" :style="{ minHeight: minHeight }">
            <div class="thumbnail">
                <img v-lazy="image || '/images/projectoverviewbanner.webp'" :alt="entity?.title" loading="lazy">
            </div>
            <div class="data">
                <div class="full flex wrap center vcenter">
                    <h1>{{ entity?.title }}</h1>
                </div>
                <p>{{ entity?.extra_description }}</p>
                <div v-if="metas && entity?.category" class="category flex wrap start vcenter">
                    <span>{{ entity?.category }}</span>
                </div>
                <div v-if="metas" class="metas flex wrap center vcenter">
                    <div class="flex wrap space vcenter">
                        <div class="flex center">
                            <i class="fe fe-16 fe-calendar"></i>
                            <span>{{ data?.publish_at || '' }}</span>
                        </div>
                        <div class="flex center">
                            <i class="fe fe-16 fe-message-circle"></i>
                            <span>{{ data?.comments || 0 }}</span>
                        </div>
                        <div class="flex center">
                            <i class="fe fe-16 fe-eye"></i>
                            <span>{{ data?.views || 0 }}</span>
                        </div>
                        <div class="flex center">
                            <i class="fe fe-16 fe-star"></i>
                            <span>{{ data?.rates || 0 }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name: 'Post',
    props: ['minHeight', 'href', 'metas', 'entity', 'data'],
    inject: ['base'],
    created() {
        this.base.API().getAsArrayBuffer(`Advertisement/Post/Download?uid=${this.entity?.id}&key=image`
            , (response) => {
                try {
                    const decoder = new TextDecoder('utf-8')
                    const json = decoder.decode(response.data)
                    JSON.parse(json)
                } catch (e) {
                    this.image = `data:image/webp;base64,${btoa(String.fromCharCode(...new Uint8Array(response.data)))}`
                }
            }, (error) => {

            })
    },
    data() {
        return {
            image: null
        }
    }
}
</script>

<style scoped src="../assets/css/components/post.css"></style>